import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function QrScanner({ open, onClose, onScan }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    let scanner;
    const t = setTimeout(async () => {
      try {
        scanner = new Html5Qrcode("qr-reader-box");
        ref.current = scanner;
        await scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: 220 }, (text) => {
          onScan(text.trim().toUpperCase());
          scanner.stop().catch(() => {});
          onClose();
        }, () => {});
      } catch (e) {
        const box = document.getElementById("qr-reader-box");
        if (box) box.innerText = "No se pudo acceder a la cámara. Permite el acceso o escribe el código manualmente.";
      }
    }, 300);
    return () => { clearTimeout(t); if (ref.current) ref.current.stop().catch(() => {}); };
  }, [open, onClose, onScan]);
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" data-testid="qr-scanner-dialog">
        <DialogHeader><DialogTitle className="font-display">Escanear código QR</DialogTitle></DialogHeader>
        <div id="qr-reader-box" className="rounded-xl overflow-hidden bg-black min-h-[260px] text-xs text-center text-muted-foreground p-2" />
        <p className="text-xs text-muted-foreground text-center">Apunta la cámara al código QR del vendedor o del cliente.</p>
      </DialogContent>
    </Dialog>
  );
}
